import type { Segment } from '../lib/models'

const COLORS = [
  '#1f8a4c',
  '#74b56b',
  '#e0a13c',
  '#8a5a2b',
  '#5f7a8c',
  '#845ef7',
  '#d6336c',
  '#495057',
  '#b0b8ab',
]

interface Props {
  title: string
  segments: Segment[]
}

export default function SurfaceBars({ title, segments }: Props) {
  const total = segments.reduce((acc, s) => acc + (s.toM - s.fromM), 0)
  if (!total) return null
  // aggregate by kind, largest first
  const byKind = new Map<string, number>()
  for (const s of segments) byKind.set(s.kind, (byKind.get(s.kind) ?? 0) + (s.toM - s.fromM))
  const entries = [...byKind.entries()].sort((a, b) => b[1] - a[1])
  const colorOf = new Map(entries.map(([k], i) => [k, COLORS[i % COLORS.length]]))

  return (
    <div className="bar-group">
      <h3>{title}</h3>
      <div className="bar-track">
        {entries.map(([kind, len]) => (
          <div key={kind} style={{ width: `${(len / total) * 100}%`, background: colorOf.get(kind) }} title={kind} />
        ))}
      </div>
      <div className="bar-legend">
        {entries.map(([kind, len]) => (
          <span key={kind}>
            <span className="swatch" style={{ background: colorOf.get(kind) }} />
            {kind} {((len / total) * 100).toFixed(0)}%
          </span>
        ))}
      </div>
    </div>
  )
}
